import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfileData } from "./services/profile-services";
import { logOut } from "@pages/login/services/login-services";
import { STORAGE_KEY } from "@constants/constants";

export const ProfileMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(false);
  const profile = useSelector((state) => state.profile.profile);
  const token = JSON.parse(localStorage.getItem(STORAGE_KEY.TOKEN));
  const profileData = JSON.parse(localStorage.getItem("profile"));
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (token && !profileData) {
      dispatch(getProfileData());
    }
  }, [dispatch, token, profileData]);

  useEffect(() => {
    if (profile) {
      localStorage.setItem("profile", JSON.stringify(profile));
    }
  }, [profile]);

  const handleLogout = () => {
    dispatch(logOut())
      .then(() => {
        // clearStorage(); // Clear storage after successful logout
        navigate("/login", { logoutResponse: "Logout successfully" });
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  return (
    <React.Fragment>
      <div className="header-profile-user bg-transparent m-auto">
        <span className="avatar-title rounded-circle bg-success-subtle text-success font-size-16">
          {user?.short_name?.[0]}
        </span>
      </div>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-xl-inline-block ms-1 me-1">
            {user?.full_name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
       
        <DropdownMenu className="dropdown-menu-end">
        {user?.type!== 1 ? 
          <Link to={`/profile/edit/${user?._id}`} className="dropdown-item">
            <i className="bx bx-check-circle font-size-16 align-middle me-1 text-success" />
            <span>Profile</span>
          </Link>
          :null}
          <Link to="/login" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>Logout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};
